/**
 * Mobile sticky bottom-nav:
 * - Hamburger ↔ header drawer menu (same open/close path as header)
 * - Search icon ↔ quick-search overlay (same open path as header search)
 * - Cart icon ↔ quick-cart drawer (same open path as header cart)
 *
 * The Sweet Dreams header shows only its logo below 768px, but keeps its
 * controls in the DOM (display: none). Clicking them programmatically still
 * works, so this file drives them exactly as it drove the old header's.
 */
(function () {
  var FOOTER_MENU_SEL = "#MsbnMenu, [data-msbn-menu-button]";
  var HEADER_MENU_SEL = ".header [data-js-menu-button], .header__icon-menu[data-js-menu-button]";
  var FOOTER_CART_SEL = "#MsbnCart, .msbn__item--cart";
  var HEADER_CART_SEL = ".header [data-js-cart-icon], [data-js-cart-icon]";
  var FOOTER_SEARCH_SEL = "#MsbnSearch, .msbn__item--search";
  // Scoped to the header on purpose: an unscoped [data-search] would match the
  // footer button itself and make it click itself forever.
  var HEADER_SEARCH_SEL = '[data-section-type="header"] [data-search]';
  var menuBound = false;
  var cartBound = false;
  var searchBound = false;

  function getFooterMenuButton() {
    return document.querySelector(FOOTER_MENU_SEL);
  }

  function getHeaderMenuButton() {
    return (
      // Sweet Dreams header first. Its hamburger deliberately carries no
      // data-js-menu-button: that attribute would hand it to the theme's own
      // drawer, which this header does not render.
      document.querySelector("[data-sdh-open]") ||
      document.querySelector(".header__row-mobile [data-js-menu-button]") ||
      document.querySelector(HEADER_MENU_SEL) ||
      document.querySelector("[data-js-menu-button]")
    );
  }

  function getFooterSearchButton() {
    return document.querySelector(FOOTER_SEARCH_SEL);
  }

  function getHeaderSearchButton() {
    return document.querySelector(HEADER_SEARCH_SEL);
  }

  function getFooterCartButton() {
    return document.querySelector(FOOTER_CART_SEL);
  }

  function getHeaderCartButton() {
    return (
      document.querySelector(".header__row-mobile [data-js-cart-icon]") ||
      document.querySelector(".header [data-js-cart-icon]") ||
      document.querySelector(HEADER_CART_SEL)
    );
  }

  function isMenuOpen() {
    return document.body.getAttribute("mobile-menu-open") === "true";
  }

  function refreshVh() {
    document.documentElement.style.setProperty(
      "--vh",
      window.innerHeight * 0.01 + "px"
    );
  }

  function syncFooterState() {
    var footerBtn = getFooterMenuButton();
    if (!footerBtn) return;

    var expanded = isMenuOpen();
    var headerBtn = getHeaderMenuButton();
    if (headerBtn && headerBtn.getAttribute("aria-expanded") === "true") {
      expanded = true;
    }

    footerBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
    document.body.toggleAttribute("data-drawer-menu-open", expanded);

    var label = footerBtn.getAttribute(
      expanded ? "data-aria-label-opened" : "data-aria-label-closed"
    );
    if (label) footerBtn.setAttribute("aria-label", label);
  }

  function onFooterMenuClick(event) {
    event.preventDefault();
    event.stopPropagation();

    var headerBtn = getHeaderMenuButton();
    if (!headerBtn) return;

    refreshVh();

    // Same open/close path as the (now-hidden) header menu icon
    headerBtn.click();

    requestAnimationFrame(syncFooterState);
    setTimeout(syncFooterState, 50);
    setTimeout(syncFooterState, 400);
  }

  function onFooterCartClick(event) {
    // Only hijack when the quick-cart drawer exists (same as header cart JS)
    if (!document.querySelector(".quick-cart")) return;

    var headerCart = getHeaderCartButton();
    if (!headerCart) return;

    event.preventDefault();
    event.stopPropagation();

    // Same open path as the header cart icon → quick-cart drawer
    headerCart.click();
  }

  function onFooterSearchClick(event) {
    // Only hijack when the quick-search overlay exists; otherwise let the link
    // fall through to the search page, same as the header search does.
    if (!document.querySelector("[data-quick-search]")) return;

    var headerSearch = getHeaderSearchButton();
    if (!headerSearch) return;

    event.preventDefault();
    event.stopPropagation();

    // Same open path as the header search icon → quick-search overlay
    headerSearch.click();
  }

  function bind() {
    var footerBtn = getFooterMenuButton();
    if (footerBtn && !menuBound) {
      footerBtn.addEventListener("click", onFooterMenuClick);
      menuBound = true;
    }

    var footerSearch = getFooterSearchButton();
    if (footerSearch && !searchBound) {
      footerSearch.addEventListener("click", onFooterSearchClick);
      searchBound = true;
    }

    var footerCart = getFooterCartButton();
    if (footerCart && !cartBound) {
      footerCart.addEventListener("click", onFooterCartClick);
      cartBound = true;
    }

    var headerBtn = getHeaderMenuButton();
    if (headerBtn && typeof MutationObserver !== "undefined") {
      if (!headerBtn.__msbnObserved) {
        var observer = new MutationObserver(syncFooterState);
        observer.observe(headerBtn, {
          attributes: true,
          attributeFilter: ["aria-expanded"],
        });
        headerBtn.__msbnObserved = true;
      }
    }

    if (!document.body.__msbnBodyObserved && typeof MutationObserver !== "undefined") {
      var bodyObserver = new MutationObserver(function () {
        if (isMenuOpen()) refreshVh();
        syncFooterState();
      });
      bodyObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["mobile-menu-open"],
      });
      document.body.__msbnBodyObserved = true;
    }

    syncFooterState();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  window.addEventListener("load", bind);
})();
